import React, { useEffect, useState } from 'react'
import SurveyForm from '../../components/survey/form/SurveyForm'
import { Link } from 'react-router-dom'
import { getSurveyFormApi } from '../../api/survey'
import { useUserStore } from '../../store/userStore'

const surveyDoneStyle = {
  padding: "2rem 1.5rem",
  border: "1px solid rgb(229, 229, 229)",
  borderRadius: "0.375rem"
}

const SurveyFormPage = () => {
  /* zustand */
  const { userInfo } = useUserStore((state) => state)
  const userId = userInfo?.user_id


  /* States */
  const [formInfo, setFormInfo] = useState(null)
  const [fileList, setFileList] = useState([])
  const [submitDate, setSubmitDate] = useState('') // 상담 신청 날짜
  const [isSubmit, setIsSubmit] = useState(false) // 상담 신청 여부

  /* UseEffect */
  useEffect(() => {
    getSurveyForm(userId)
  }, [userId])

  /* Methods */
  const getSurveyForm = async (userId) => {
    try {
      const response = await getSurveyFormApi(userId)

      if (response.data.code === 200) {
        if (response.data.resData) {
          setFormInfo(response.data.resData.json_data)
          setFileList(response.data.resData.files)
          setSubmitDate(response.data.resData.date)
          setIsSubmit(true)

        } else {
          setFormInfo(null)
          setFileList([])
          setSubmitDate('')
          setIsSubmit(false)

        }
      }
    } catch (error) {
      // console.error(error);
      setFormInfo(null)
      setFileList([])
      setSubmitDate('')
      setIsSubmit(false)

    }
  }

  return (
    <div>
      <div className='mb-5'>
        <h2 className='h3 mb-3'>상담 신청서</h2>
        <p className='fs-5'>상세한 진단과 처방을 하기 위해 학생의 현 상태를 확인합니다.</p>
      </div>

      {isSubmit &&
        <div className='mb-5 lh-lg text-center' style={surveyDoneStyle}>
          <p>
            신청서를 제출하였습니다.
            {submitDate ? <span>&#40;{submitDate}&#41;</span> : ''}
          </p>
          <p>3일 이내에 진로 검사 코드가 발급됩니다.</p>
          <p><Link to='/survey/test' className='text-primary'>SLT/MCI 검사 페이지</Link> 에서 코드를 확인하세요.</p>
        </div>
      }

      <div className='form-wrap card' style={{ padding: "60px 40px", border: "1px solid #e5e5e5" }}>
        <h3 className='h3 text-center mb-5'>상담 신청서</h3>
        <SurveyForm formInfo={formInfo} savedFileList={fileList} setIsSubmit={setIsSubmit} />
      </div>
    </div>
  )
}

export default SurveyFormPage